import { KeyCode } from '@core/assistant/providers/scriptPlayer/linearScriptPlayer';

export enum TutorialId {
  NavigationBasics = 'navigation-basics',
  LanguageSettings = 'language-settings',
  Teleport = 'teleport',
}

export enum TutorialHighlightKey {
  ProfileAvatarButton = 'profile-avatar-btn',
  SettingsChevron = 'settings-chevron',
  LanguageDropdown = 'language-dropdown',
  TeleportFirstLocation = 'teleport-first-location',
}

export interface TutorialStep {
  id: string;
  /** Narration text, spoken via TTS and shown in the step-text box — plain text, see `text.ts`. */
  narration: string;
  highlightTarget?: TutorialHighlightKey;
  awaitClickSelector?: string;
  awaitKeys?: KeyCode[] | 'ANY';
  /** Letter shown in a floating `KeyCap` hint from narration start until the awaited key is captured. */
  keyHintLabel?: string;
}

export interface TutorialDefinition {
  id: TutorialId;
  /** i18n key for the display name shown in the tutorial-choice radio list. */
  titleKey: string;
  steps: TutorialStep[];
}

export interface ITutorialContext {
  activeTutorialId: TutorialId | null;
  isTutorialRunning: boolean;
  activeHighlightTarget: TutorialHighlightKey | null;
  activeKeyHint: string | null;
  activeStepText: string | null;
  hasNarrationStarted: boolean;
  completedTutorialIds: TutorialId[];
  completedNoticeTutorialId: TutorialId | null;
  isPromptForced: boolean;
  startTutorial: (id: TutorialId) => void;
  stopTutorial: () => void;
  openTutorialPrompt: () => void;
  closeTutorialPrompt: () => void;
  dismissCompletionNotice: () => void;
}
